module.exports = __webpack_public_path__ + "static/media/ASP1.bd118b8c.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/ASP1.png
// module id = 876
// module chunks = 0